import { useAsync } from "@/shared/hooks";
import { apolloStatsLoader } from "../loaders/apollo-stats-loader";
import { StatsGrouping, StatsObject } from "../const";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { StatsQueryParams } from "@suns/api/generated-client/apollo";

export const useApolloStats = (
  object: StatsObject,
  grouping: StatsGrouping,
  params: StatsQueryParams,
  includeTotals = false
) => {
  const stats = useAsync(apolloStatsLoader, {
    object,
    grouping,
    params,
    includeTotals,
  });

  return stats;
};
